import React, { useContext, useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { Badge, Button, Card, CardContent, Switch } from "@material-ui/core";
import AuthContext from "../../../hooks/authContext";
import styles from "../Accounts.module.scss";
import { DowngradeDetailsDialog } from "./PaymentSuccess";
import { CommonConfirmationDialog } from "../../../components/DialogComponent/SupplyDataDialog";
import { useToast } from "../../../hooks/useToast";
import PaymentMethodsList from "./PaymentMethodsList";

const SubscriptionList = (props) => {
    const {
      prices,
      isAnnual,
      yearlyPrice,
      numUsers,
      setNewPrice,
      setNewPriceId,
      handleUpdateStripeSubscription,
      loader,
      priceState,
      customerBalance,
      newPrice,
      setPlanInfo,
    } = props;
                  
  const auth = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const [renewOpen, setRenewOpen] = useState(false);
  const isPending = auth?.userProfile?.pendingVerifications?.length > 0 && auth?.userProfile?.pendingVerifications?.[0]?.status === "pending";

 const BASE_PRICE_MAP = [
  { name: "Standard", amount: 99 },
  { name: "Plus", amount: 249 },
  { name: "Professional", amount: 375 },
  { name: "Standard", amount: 990 },
  { name: "Plus", amount: 2499 },
  { name: "Professional", amount: 3750 },
  ];
  const PRICE_IDS_BY_ENV = {
    dev: [
      "price_1RY2GjH54HzvHwSd7xIHfw9Z",
      "price_1RY2L2H54HzvHwSdeCNKydVJ",
      "price_1RY2SdH54HzvHwSdE62LQFMq",
      "price_1RYSEYH54HzvHwSdWnZO85Pk",
      "price_1RYSH0H54HzvHwSdPNwhG0Zf",
      "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
    ],
    stage: [
      "price_1Rg4StHG9KfCFcBtk62AyLjl",
      "price_1Rg4VOHG9KfCFcBtUdpounGQ",
      "price_1Rg4YeHG9KfCFcBthKGhErSl",
      "price_1Rg4TIHG9KfCFcBti234fUD6",
      "price_1Rg4VsHG9KfCFcBtOKbt91yg",
      "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
    ],
    prod: [
      "price_1RsdHLHPX5Uwv3eVePGNLRLj",
      "price_1RsdPgHPX5Uwv3eV7k7eyln8",
      "price_1RsdVFHPX5Uwv3eVbavvVBji",
      "price_1RsdLlHPX5Uwv3eV3ozmcddw",
      "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
      "price_1RsdVaHPX5Uwv3eVGScEMH75",
    ],
  };
  const ENV = process.env.REACT_APP_CUSTOM_ENV || "dev";

  const priceIds = PRICE_IDS_BY_ENV[ENV];
  const priceMap = {};

  priceIds?.forEach((id, index) => {
    priceMap[id] = BASE_PRICE_MAP[index];
  });

  const handleDialogOpen = (priceId) => {
    if(auth?.userProfile?.subscriptions?.data?.length > 0){
      const oldPriceId = auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id;
      const newPriceId = priceId;
      
      const oldPriceAmount = priceMap[oldPriceId]?.amount;
      const newPriceAmount = priceMap[newPriceId]?.amount;
      
      // if (newPriceId === oldPriceId) {
      //   setRenewOpen(true);
      //   return;
      // } else 
      if (newPriceAmount < oldPriceAmount) {
        setOpen(true);
        return;
      } else {
        handleUpdateStripeSubscription(priceId);
      }
    } else {
      handleUpdateStripeSubscription(priceId);
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
  }

  const handleConfirmDialog = () => {
    setOpen(false);
    handleUpdateStripeSubscription(newPrice);
  }

  const handleRenewConfirm = () => {
    setRenewOpen(false);
    handleUpdateStripeSubscription(newPrice);
  }

  const handleRenewClose = () => {
    setRenewOpen(false);
  }

  function getPriceDisplay(priceId) {
    const priceObj = prices?.find((p) => p.id === priceId);
    if (!priceObj) return null;
    const adjustedAmount = priceObj.unit_amount * 10;
    // const oldAmount = (adjustedAmount / 100).toFixed(2);
    const oldAmount = priceObj.unit_amount;
    const newAmount = (adjustedAmount / 12 / 100).toFixed(2);
    return { oldAmount, newAmount };
  }

  const PRICE_IDS_ENV = {
    dev: [
      "price_1RY2GjH54HzvHwSd7xIHfw9Z",
      "price_1RY2L2H54HzvHwSdeCNKydVJ",
      "price_1RY2SdH54HzvHwSdE62LQFMq",
    ],
    stage: [
      "price_1Rg4StHG9KfCFcBtk62AyLjl",
      "price_1Rg4VOHG9KfCFcBtUdpounGQ",
      "price_1Rg4YeHG9KfCFcBthKGhErSl",
    ],
    prod: [
      "price_1RsdHLHPX5Uwv3eVePGNLRLj",
      "price_1RsdPgHPX5Uwv3eV7k7eyln8",
      "price_1RsdVFHPX5Uwv3eVbavvVBji",
    ],
  };

  const planNameToPriceId = {};

  PRICE_IDS_ENV[ENV]?.forEach((id, index) => {
    const { name } = BASE_PRICE_MAP[index];
    if (!planNameToPriceId[name]) {
      planNameToPriceId[name] = id;
    }
  });

  const getPriceInfo = (planName) => {
    const selectedPriceId = planNameToPriceId[planName];
    return selectedPriceId ? getPriceDisplay(selectedPriceId) : null;
  };

  const formatStripeAmount = (amount) => {
    return `$${(amount / 100).toFixed(0)}`;
  };

  const currentPlanId = auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id;
  const subscriptionStatus = auth?.userProfile?.subscriptionDetails?.status;
  const currentPeriodEnd = auth?.userProfile?.subscriptionDetails?.current_period_end;
  const currentPeriodEndDate = new Date(currentPeriodEnd * 1000);
  const today = new Date();
  const diffInDays = (currentPeriodEndDate - today) / (1000 * 60 * 60 * 24);
  const isExpiringSoon = subscriptionStatus === "active" && (diffInDays <= 5 && diffInDays >= 0);


  return (
    <>
    <div className={`${styles.gridWrapper} mt-20 p-20`}>
      {isAnnual === true &&
        yearlyPrice?.map((plan) => {
          const priceInfo = getPriceInfo(plan?.product?.name);
          const price = priceState?.[plan?.product?.name]?.yearly;
          const isCurrentPlanActive = currentPlanId === plan?.id && subscriptionStatus === "active";

          return (
            <Card
              className={`${styles.cardUpgrade} ${
                plan?.product?.name === "Plus" ? styles.popular : ""
              } dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
            >
              <div className={styles.badgeWrapper}>
                {plan?.product?.name === "Plus" && (
                  <div className={styles.popularBadge}>
                    <Badge className={styles.badge}>Most popular</Badge>
                  </div>
                )}
              </div>

              <CardContent className="p-20">
                <div className="d-flex flex-space-between">
                  <div>
                    <h2 className={styles.titleUpgrade}>
                      {plan?.product?.name}
                    </h2>
                    <p className={styles.descriptionUpgrade}>
                      {plan?.product?.description}
                    </p>
                    <div className={styles.priceRow}>
                      <span className={styles.price}>
                        {plan?.product?.name === "Users Plan" && numUsers > 1
                          ? formatStripeAmount(
                              (price || plan?.unit_amount) * numUsers
                            )
                          : price
                          ? formatStripeAmount(price)
                          : formatStripeAmount(plan?.unit_amount)}
                      </span>
                      <span>
                        {plan?.product?.name === "Users Plan"
                          ? "/month per user"
                          : "/year"}
                      </span>
                    </div>
                  </div>
                  {/* {plan?.product?.name === "Users Plan" && (
                          <div className="d-flex flex-direction-column flex-center mt-1">
                            <h4 className="mb-8">QTY : </h4>
                            <input
                              id="numUsers"
                              type="number"
                              min="1"
                              value={numUsers}
                              onChange={(e) =>
                                setNumUsers(parseInt(e.target.value) || 1)
                              }
                              style={{ width: "90px", fontSize:"20px", fontWeight:"700", color:"#020817", border:"1px solid hsl(214.3, 31.8%, 91.4%)", borderRadius:"4px" }}
                            />
                            <span className="mt-5">
                              {numUsers} x{" "}
                              {price
                                ? formatStripeAmount(price)
                                : formatStripeAmount(plan?.unit_amount)}{" "}
                              per user
                            </span>
                          </div>
                        )} */}
                </div>
                <div className="mb-20">
                  {priceInfo && (
                    <>
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#666",
                        }}
                      >
                        {formatStripeAmount(priceInfo?.oldAmount)}/month
                      </span>{" "}
                      <span style={{ color: "#27ae60", fontWeight: "bold" }}>
                        ${priceInfo?.newAmount}/month
                      </span>
                    </>
                  )}
                </div>
                <Button
                  disabled={
                    loader === true || isCurrentPlanActive
                  }
                  className={`${
                    auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id ===
                      plan?.id &&
                    auth?.userProfile?.subscriptionDetails?.status === "active"
                      ? styles.buttonDisabled
                      : styles.button
                  } ${
                    plan?.product?.name === "Users Plan"
                      ? styles.primaryButton
                      : ""
                  }`}
                  onClick={() => {
                    // if (isCurrentPlanActive && !isExpiringSoon) {
                    //     return;
                    // }  else
                    if (isPending) {
                      toast?.({
                        title: "Verification Required",
                        description: "Please verify your bank account first. You cannot change the plan until verification is complete.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (plan?.product?.name === "Users Plan") {
                      setNewPrice(plan?.id);
                      setNewPriceId(plan?.id);
                    } else {
                      handleDialogOpen(plan?.id);
                      setNewPrice(plan?.id);
                      setPlanInfo({planName: plan?.product?.name, description: plan?.product?.description, amount: plan?.unit_amount, yearly: true});
                    }
                  }}
                >
                  {/* {isCurrentPlanActive ? isExpiringSoon ? "Renew Plan" : "Current Plan" : "Select This Plan"} */}
                  {isCurrentPlanActive ? "Current Plan" : "Select This Plan"}
                </Button>

                <div className="mt-20">
                  <div className={styles.featureTitle}>This includes:</div>
                  <ul className={styles.featureList}>
                    {plan?.product?.marketing_features?.map(
                      (feature, index) => (
                        <li key={index} className={styles.featureItem}>
                          <CheckOutlinedIcon
                            fontSize="small"
                            className={styles.icon}
                          />
                          <span className="dark:text-white text-[#020817]">
                            {feature.name}
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </CardContent>
            </Card>
          );
        })}

      {isAnnual !== true &&
        prices?.map((plan) => {
          const price = priceState?.[plan?.product?.name]?.monthly;
          const isCurrentPlanActive = currentPlanId === plan?.id && subscriptionStatus === "active";
          return (
            <Card
              className={`${styles.cardUpgrade} ${
                plan?.product?.name === "Plus" ? styles.popular : ""
              } dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
            >
              <div className={styles.badgeWrapper}>
                {plan?.product?.name === "Plus" && (
                  <div className={styles.popularBadge}>
                    <Badge className={styles.badge}>Most popular</Badge>
                  </div>
                )}
              </div>

              <CardContent className="p-20">
                <div className="d-flex flex-space-between">
                  <div>
                    <h2 className={styles.titleUpgrade}>
                      {plan?.product?.name}
                    </h2>
                    <p className={styles.descriptionUpgrade}>
                      {plan?.product?.description}
                    </p>
                    <div className={styles.priceRow}>
                      <span className={styles.price}>
                        {plan?.product?.name === "Users Plan" && numUsers > 1
                          ? formatStripeAmount(
                              (price || plan?.unit_amount) * numUsers
                            )
                          : price
                          ? formatStripeAmount(price)
                          : formatStripeAmount(plan?.unit_amount)}
                      </span>
                      <span>
                        {plan?.product?.name === "Users Plan"
                          ? "/month per user"
                          : "/month"}
                      </span>
                    </div>
                  </div>
                  {/* {plan?.product?.name === "Users Plan" && (
                          <div className="d-flex flex-direction-column flex-center mt-1">
                            <h3 className="mb-8">QTY : </h3>
                            <input
                              id="numUsers"
                              type="number"
                              min="1"
                              value={numUsers}
                              onChange={(e) =>
                                setNumUsers(parseInt(e.target.value) || 1)
                              }
                              style={{ width: "90px", fontSize:"20px", fontWeight:"700", color:"#020817", border:"1px solid hsl(214.3, 31.8%, 91.4%)", borderRadius:"4px" }}
                            />
                            <span className="mt-5">
                              {numUsers} x{" "}
                              {price
                                ? formatStripeAmount(price)
                                : formatStripeAmount(plan?.unit_amount)}{" "}
                              per user
                            </span>
                          </div>
                        )} */}
                </div>
                 {/* loader === true || (isCurrentPlanActive && !isExpiringSoon) */}
                <Button
                  disabled={
                    loader === true || isCurrentPlanActive
                  }
                  className={`${
                    auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id ===
                      plan?.id &&
                    auth?.userProfile?.subscriptionDetails?.status === "active"
                      ? styles.buttonDisabled
                      : styles.button
                  } ${
                    plan?.product?.name === "Users Plan"
                      ? styles.primaryButton
                      : ""
                  }`}
                  onClick={() => {
                    // if (isCurrentPlanActive && !isExpiringSoon) {
                    //     return;
                    // } else
                    if (isPending) {
                      toast?.({
                        title: "Verification Required",
                        description: "Please verify your bank account first. You cannot change the plan until verification is complete.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (plan?.product?.name === "Users Plan") {
                      setNewPrice(plan?.id);
                      setNewPriceId(plan?.id);
                    } else {
                      handleDialogOpen(plan?.id);
                      setNewPrice(plan?.id);
                      setPlanInfo({planName: plan?.product?.name, description: plan?.product?.description, amount: plan?.unit_amount, yearly: false});
                    }
                  }}
                >
                  {/* {isCurrentPlanActive ? isExpiringSoon ? "Renew Plan" : "Current Plan" : "Select This Plan"} */}
                  {isCurrentPlanActive ? "Current Plan" : "Select This Plan"}
                </Button>

                <div className="mt-20">
                  <div className={styles.featureTitle}>This includes:</div>
                  <ul className={styles.featureList}>
                    {plan?.product?.marketing_features?.map(
                      (feature, index) => (
                        <li key={index} className={styles.featureItem}>
                          <CheckOutlinedIcon
                            fontSize="small"
                            className={styles.icon}
                          />
                          <span className="dark:text-white text-[#020817]">
                            {feature.name}
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </CardContent>
            </Card>
          );
        })}
    </div>

    {open && (
      <DowngradeDetailsDialog  
      open={open}
      onConfirm={handleConfirmDialog}
      onClose={handleCloseDialog}
      data={auth?.userProfile}
      balance={customerBalance}
      newPrice={newPrice}
      />
    )}

    {renewOpen && (
      <CommonConfirmationDialog  
        open ={renewOpen}
        onConfirm={handleRenewConfirm}
        onClose={handleRenewClose} 
        title={"Renew Current Plan"}
        message={"You are about to renew your current subscription. The payment will be deducted automatically from your default payment method."} 
      />
    )}
    </>
  );
};

export default SubscriptionList;
